import { prefixObjectValues } from '../../utils';
const form = {
  startDate: 'start-date',
  endDate: 'end-date',
  numOfFtes: 'num-of-ftes',
  fteShiftsPerYear: 'fte-shifts-per-year',
  hoursPerShift: 'hours-per-shift',
  totalShifts: 'total-shifts',
  totalHours: 'total-hours',
  totalFTEs: 'total-fte',
  minRvusPerShift: 'min-rvus-per-shift',
  laborReqType: 'labor-req-type',
  numRvusReq: 'num-rvus-req',
};
export default prefixObjectValues(form, 'labor-metrics-form');
